import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { setTrk, TrkTag } from '@nerdwallet/nw-client-lib/trk-helper';
/** Helper method to construct a url w/ tracking parameters
 *
 * @param                    Object
 *  @key url                 string  base link
 *  @key trkElement          string  TrkElement from @nerdwallet/nw-client-lib/trk-helper
 *  @key trkPageType         string  TrkPageType from @nerdwallet/nw-client-lib/trk-helper
 *  @key trkLocation         string  slug representing the location of the referrer
 *  @key trkSectionCategory  string  slug representing the page section context of the referrer
 *  @key trkTaxonomy         Object  window.nwPageTaxonomy obj
 *
 * @return                string  url w/ tracking data as query params
 */

export var buildLink = function buildLink(_ref) {
  var _baseParams;

  var navigationSourceImpressionId = _ref.navigationSourceImpressionId,
      url = _ref.url,
      trkElement = _ref.trkElement,
      trkPageType = _ref.trkPageType,
      trkLocation = _ref.trkLocation,
      trkSectionCategory = _ref.trkSectionCategory,
      trkTaxonomy = _ref.trkTaxonomy;
  var baseParams = (_baseParams = {}, _defineProperty(_baseParams, TrkTag.location, trkLocation), _defineProperty(_baseParams, TrkTag.element, trkElement), _defineProperty(_baseParams, TrkTag.pageType, trkPageType), _defineProperty(_baseParams, TrkTag.sectionCategory, trkSectionCategory), _baseParams);
  var params = navigationSourceImpressionId ? _objectSpread(_objectSpread({}, baseParams), {}, {
    navigation_source_impression_id: navigationSourceImpressionId
  }) : baseParams;
  return setTrk({
    url: url,
    taxonomy: trkTaxonomy,
    params: params
  });
};